import MenuCard from './Components/MenuCard.js';
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TopAppBar from './Components/TopAppBar.js';
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import WordListDialog from './Components/WordListDialog.js';
import iguana from './iguana.jpg';
import Config from './Config.json';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import Typography from '@mui/material/Typography';
import {Link} from "react-router-dom";

const breadcrumbs = [
  <Link underline="hover" to="/" key="1" color="white" href="/">
    Vocab App
  </Link>,
  <Typography key="3" color="white">
    Curriculum
  </Typography>,
];

var loadingData = [
    {
      "title":"School",
      "picture": "iVBORw0KGgoAAAANSUhEUgAAABcAAAABCAIAAAC6x6JxAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAAWSURBVBhXYwCC////o5EQgJ+NIBkYAEUrF+lZr6HIAAAAAElFTkSuQmCC",
      "description": "Learn to express feelings and needs",
      "include": true,
      "wordCount":69,
      "wordList": [
        {
          "id":0,
          "word": "louer",
          "definition":"to rent",
          "familiarity": 69,
          "include":true,
        },
      ]
    }
  ]

function CurriculumPage() {
  const [wordsPageData, setWordsPageData] = useState(loadingData);
  const [openDiag, setOpenDiag] = useState(false);
  //index of menuCard chosen by user
  const [chosenIndex, setChosenIndex] = useState(0);
  const [currentWordList, setCurrentWordList] = useState(wordsPageData[0]["wordList"]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [checkBoxState, setCheckBoxState]  = useState(wordsPageData.map(() => null));

  const [enableSave, setEnableSave] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);

  React.useEffect(() => {
      axios.get(Config.urlStub + "/wordData").then((response) => {
        //lessonData = response.data;
        // console.log("lessonData is", response.data);
        wordsPageData.map((value, index) => {
          // console.log("include is", value.include);
        })
        setWordsPageData(response.data);
        setCheckBoxState(response.data.map((wordData) => wordData.include));
      });
      // console.log("updating wordsPageData", wordsPageData);
    }, []);

  function toggleCheckboxState(index) {
    setEnableSave(true);
    // console.log("toggle checkbox triggered", index)
    // console.log("old state", checkBoxState)
    const newCheckBoxState = checkBoxState.map((c, i) => {
      if (i === index) {
        //update value of chosen index
        return !checkBoxState[i];
      } else {
        //do nothing
        return c;
      }
    });
    // console.log("new state", newCheckBoxState)
    setCheckBoxState(newCheckBoxState);
  }

  function handleOpen(index) {
    setOpenDiag(true);
    setChosenIndex(index);
    setCurrentWordList(wordsPageData[index]["wordList"]);
    setDialogTitle(wordsPageData[index]["title"]);
  }

  function handleClose() {
    setOpenDiag(false);
  }

  function handleSnackClose() {
    setSnackOpen(false);
  }

  function saveSettings() {
    // console.log('the fab is being flicked');
    axios.post(Config.urlStub + "/saveWordBanks", checkBoxState).then((response) => {
        setEnableSave(false);
        //TODO: add snackbar for displaying success message
        setSnackOpen(true);
      }).catch((response) => {
        //TODO: add snackbar for displaying fail message
        // console.log("save failed")
      });
  }

  return (
    <Box sx={{ flexGrow:1 }} className="App-header">
      <TopAppBar breadcrumbs={breadcrumbs}/>
    
      <Grid container justifyContent="center" sx={{ p: 2}} spacing={2} style={{marginTop:"60px"}} >
        {wordsPageData.map((value, index) => {
          return (
            <Grid item xs={2} >
              <MenuCard imgbase64={value.picture} handleOpen={handleOpen} title={value.title} include={checkBoxState[index]} index={index}
                desc={value.description} wordData={value.wordList} wordCount={value.wordCount} updateCheckbox={toggleCheckboxState} 
                />
              
            </Grid>
          )
        })}
      </Grid>

        <Snackbar open={snackOpen} autoHideDuration={1000} onClose={handleSnackClose} anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
          <Alert severity="success">
            Save Success!
          </Alert> 
        </Snackbar>

        <Fab variant="extended" disabled={!enableSave} onClick={() => saveSettings()}
          style={{margin: 0, top: 'auto', right: '5%', bottom: '5%', left: 'auto', position: 'fixed'}}>
          <SaveIcon sx={{ mr: 1 }} />
          Save Settings
        </Fab>

    </Box>
  );
}

export default CurriculumPage